import * as React from 'react'
import { inject, observer } from 'mobx-react'
import LocalizationStore from '../../Stores/LocalizationStore'
// import { NavLink } from 'react-router-dom'

interface IFooterProps {
    localizationStore?: LocalizationStore
}

@inject('localizationStore')

@observer
export default class FooterView extends React.Component<IFooterProps> {

    render() {
        let ls = this.props.localizationStore!

        return (
            <footer className="footer">
                <div className="container footerInWrapper">
                    <p className="copy">&copy;{(new Date()).getFullYear()}&nbsp;{ls.t!('copyright')}</p>
                    {/* <NavLink to="/feedback">
                        {ls.t('feedback')}
                    </NavLink> */}
                </div>
            </footer>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/FooterView.tsx